import { Component, Input, OnInit, SecurityContext, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DashboardComponent } from '../../models/DashboardComponent';
import { DataFormatterService } from '../../services/data-formatter.service';

@Component({
    selector: 'gtw-ex-kpi',
    templateUrl: './ex-kpi.component.html',
    styleUrls: ['./ex-kpi.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ExKPIComponent implements OnInit {
    @Input()
    options!: DashboardComponent;

    numberData: string = '';

    constructor(private dataFormatterService: DataFormatterService,
        private domSanitizer: DomSanitizer) { }

    ngOnInit(): void {
        if(this.options.extraOptions.componentSettings.alwaysNegative){
            this.options.data = Math.abs(this.options.data) * -1;
        }
        if (this.options.extraOptions.componentSettings.format) {
            var formatter = this.dataFormatterService.getFormatter(this.options.extraOptions.componentSettings.format);
            if (formatter) {
                this.numberData = this.dataFormatterService.getFormatter("Number")?.func(this.options.data,false);
                this.options.data = formatter!.func(this.options.data);//this.domSanitizer.sanitize(SecurityContext.HTML,formatter!.func(this.options.data));

            }

            // if(this.options.extraOptions.componentSettings.percentBy){

            // }
        }
    }
}
